import { StackGrid } from "@data-display/layout/StackGrid";
import { styled } from "@mui/material/styles";

const headerPrefix = "DRPHeaderContainer";
export const headerClasses = {
  root: `${headerPrefix}-root`,
};

export const DRPHeaderContainer = styled(StackGrid)(({ theme }) => ({
  [`&.${headerClasses.root}`]: {
    alignItems: "start",
    backgroundColor: theme.palette.surface.main,
    flexDirection: "row",
    padding: theme.spacing(2),
    overflow: "hidden",
    "& > .MuiStack-root": {
      overflow: "hidden",
    },
  },
}));
